import axios from 'axios';
import { API_BASE_URL } from '../../../../constants';
import { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';

export type TMenuData = {
  title: string;
  url: string;
};

export function useGetMenuData(category: string) {
  const [data, setData] = useState<TMenuData[]>([]);

  useEffect(() => {
    if (!category || category === '') return;
    axios.get(`${API_BASE_URL}/menus?category=${category}`).then((res) => {
      if (res.data.data.length === 0) return;
      const newValue = res.data.data.map((item) => {
        return {
          title: item.title,
          url: item.url,
        };
      });

      setData(newValue);
    });
  }, [category]);

  return data;
}
